import axios from "axios";
import { base_url } from "./ApiConst";
import { Token } from "./Token";
import { STORAGE_CONSTANTS } from "../shared/Constants/Constants";
import { toast } from "react-toastify";

export const axiosInstance = axios.create({
  baseURL: base_url,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const isLoggedIn =
      localStorage.getItem(STORAGE_CONSTANTS.IS_LOGGED_IN) === "true";

    if (isLoggedIn) {
      const userToken = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);
      config.headers["Authorization"] = `Token ${userToken}`;
    } else {
      config.headers["Authorization"] = Token; 
      // or whatever your default token variable is
    }

    return config;
  },
  (error) => Promise.reject(error)
);


// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // Show toast error message
//     if (error.response && error.response.data && error.response.data.detail) {
//       toast.error(error.response.data.detail);
//     } else if (error.message) {
//       toast.error(error.message);
//     } else {
//       toast.error("An unexpected error occurred.");
//     }
//     return Promise.reject(error);
//   }
// );
